import React, { Fragment } from 'react'
import Icon from 'assets/icons/Icon'
import theme from 'theme'
import { useHistory } from 'react-router-dom'

import { CHAPTERS } from '../../../constants'

const AboutMode = ({ t, activeSoundsLoaded }) => {
  let history = useHistory()

  const onChapterClick = () => {
    const firstRoom = CHAPTERS.find((ch) => ch.id === 1).name
    setTimeout(() => {
      history.push(`/chapter?name=${firstRoom}`)
    }, 200)
  }

  return (
    <Fragment>
      {activeSoundsLoaded && (
        <div className="startHereText" style={{ opacity: '0.64' }} onClick={onChapterClick}>
          {t('letsGoStartIt').toUpperCase()}
        </div>
      )}
      <div
        style={{
          maxWidth: '25vw',
          perspective: '2000px',
        }}
      >
        <div
          style={{
            transform: 'rotateY(20deg)',
            overflowY: 'scroll',
            maxHeight: 'calc(100vh - (11.11vh * 2))',
            paddingRight: '15px',
          }}
        >
          {t('aboutProject')
            .split('\n')
            .map((line, index) => (
              <p
                key={index + new Date().getTime()}
                style={{
                  marginBottom: '20px',
                  lineHeight: '150%',
                }}
              >
                {line}
              </p>
            ))}
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          bottom: 0,
          transform: 'translateX(-50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          maxWidth: '19.6vw',
        }}
      >
        <Icon name="headphones" width={36} height={36} fill={theme.white} className="headphones" />
        <div>{t('headphonesOn')}</div>
      </div>
    </Fragment>
  )
}

export default AboutMode
